import { useEffect } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faTimes } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModule, FileInput, Form, Link,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

const defaultState = {
  showInvoiceFileInput: false,
  showQuoteFileInput: false,
}

const QuotesAndInvoicing = (props) => {
  const { agency, agencyFormPayload } = props || {}
  const {
    entityState: {
      options: {
        quote_payment_template_id,
        quote_template_id,
      },
    },
    handlers,
    setEntityState,
  } = agencyFormPayload

  const [state, setState] = useSetState(defaultState)
  const { showInvoiceFileInput, showQuoteFileInput } = state

  const invoicePDFUrl = digObject(agency, 'invoice_pdf.original')
  const quotePDFUrl = digObject(agency, 'quote_pdf.original')

  useEffect(() => {
    setState({
      showInvoiceFileInput: !invoicePDFUrl,
      showQuoteFileInput: !quotePDFUrl,
    })
  }, [invoicePDFUrl, quotePDFUrl])

  return (
    <DashboardModule title="Quotes &amp; Invoicing">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Quote Template #">
            <input
              name="options.quote_template_id"
              value={quote_template_id}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field
            label="Quote PDF"
            marginTop={['large', 0]}
          >
            <Box alignItems="center">
              {showQuoteFileInput && (
                <FileInput
                  input={{
                    onChange: (fileData) => { setEntityState({ quote_pdf_file: fileData }) },
                    value: quotePDFUrl,
                  }}
                />
              )}

              {!showQuoteFileInput && (
                <Box position="relative">
                  <input disabled value="File Uploaded" />

                  <Box position="absolute" right={16} top={10} width="fit-content">
                    <Link greyLink href={quotePDFUrl} target="blank">
                      <FontAwesomeIcon icon={faDownload} />
                    </Link>

                    <Link
                      greyLink
                      onClick={() => setState({ showQuoteFileInput: true })}
                      textProps={{ marginLeft: 'medium' }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Link>
                  </Box>
                </Box>
              )}
            </Box>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Quote Payment Template #">
            <input
              name="options.quote_payment_template_id"
              value={quote_payment_template_id}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field
            label="Invoice PDF"
            marginTop={['large', 0]}
          >
            <Box position="relative" alignItems="center">
              {showInvoiceFileInput && (
                <FileInput
                  input={{
                    onChange: (fileData) => { setEntityState({ invoice_pdf_file: fileData }) },
                    value: invoicePDFUrl,
                  }}
                />
              )}

              {!showInvoiceFileInput && (
                <Box position="relative">
                  <input disabled value="File Uploaded" />

                  <Box position="absolute" right={16} top={10} width="fit-content">
                    <Link greyLink href={invoicePDFUrl} target="blank">
                      <FontAwesomeIcon icon={faDownload} />
                    </Link>

                    <Link
                      greyLink
                      onClick={() => setState({ showInvoiceFileInput: true })}
                      textProps={{ marginLeft: 'medium' }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </Link>
                  </Box>
                </Box>
              )}
            </Box>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

QuotesAndInvoicing.propTypes = {
  agency: PropTypes.object,
  agencyFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      quote_template_id: PropTypes.number,
      quote_payment_template_id: PropTypes.number,
    }),
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default QuotesAndInvoicing
